import script from "./AccountEmailAdminPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountEmailAdminPanel.vue?vue&type=script&setup=true&lang=js"

import "./AccountEmailAdminPanel.vue?vue&type=style&index=0&id=0362bddd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0362bddd"]])

export default __exports__